import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSignOut = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M10 8h5.25c.412 0 .75.338.75.75v1.5c0 .413-.338.75-.75.75H10a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h5.25c.412 0 .75.337.75.75v1.5c0 .412-.338.75-.75.75H10c-3.313 0-6-2.688-6-6V14c0-3.312 2.687-6 6-6Zm14.443 1.22-1.225 1.224c-.3.3-.294.781.012 1.069l7.069 6.862h-15.55a.752.752 0 0 0-.75.75v1.75c0 .413.338.75.75.75H30.3L23.23 28.48a.753.753 0 0 0-.012 1.069l1.225 1.224a.75.75 0 0 0 1.062 0L35.78 20.526a.75.75 0 0 0 0-1.063L25.505 9.213a.756.756 0 0 0-1.062.006Z" })
});
export default SvgSignOut;
